import { FC } from 'react';
import { CircleAlert } from 'lucide-react';

/**
 * Shown on the subscribe page when the selected degree is a master's degree,
 * to make clear that a completed bachelor's degree is required before a student
 * can pursue a master's degree.
 */
export const MasterPrerequisiteNotice: FC = () => {
  return (
    <section
      role="note"
      className="flex items-start gap-3 rounded-xl bg-(--warning-W100) border border-(--warning-W700)/30 p-4"
    >
      <CircleAlert className="text-(--warning-W700) shrink-0 mt-0.5" size={20} aria-hidden />
      <div className="flex flex-col gap-1">
        <span className="[font-family:var(--font-montserrat)]! [font-size:var(--fs-l4)]! font-semibold leading-tight text-(--warning-W700)">
          A completed bachelor&apos;s degree is required
        </span>
        <p className="m-0! [font-size:var(--fs-p3)]! leading-[150%] text-(--neutral-black-NB700)!">
          You must finish a bachelor&apos;s degree before you can complete a master&apos;s degree.
          You can subscribe and start now, but a master&apos;s degree cannot be conferred until your
          bachelor&apos;s degree is complete.
        </p>
      </div>
    </section>
  );
};
